import { ICenterStatisticsView, IDonor } from ".";

export interface IWageAndTravelRequest {
    id: number,
    centerId: number,
    donorId: number,
    donorShieldId: number,
    editKey: string,
    type: number,
    status: number,
    medicalPto: number,
    reimbursementImportance: null,
    email: string,
    mobilePhone: string,
    firstName: string,
    lastName: string,
    fullName: string,
    birthDate: string,
    donationDate: string,
    expirationDate: string,
    isDonationConfirmed: boolean,
    createdDateTime: string,
    formsCompletedDateTime: string,
    travelEmailSendDateTime: string,
    decisionDateTime: string,
    declineReasonText: string,
    addressLine1: string,
    city: string,
    state: number,
    postalCode: string,
    roundTripMiles: number,
    hotelLodgingExpense: number,
    flightAndTrainExpense: number,
    carServiceExpense: number,
    travelReceiptsFile: string,
    travelReceiptsUploadedDateTime: string,
    roundTripInstances: { tripDate: Date, tripReason: string }[],
    ssn: string,
    ssnDecrypted: string,
    incomeIrsYear: number,
    incomeIrsYearGross: number,
    incomePayStubGross: number,
    incomePayStubStartDate: string,
    incomePayStubEndDate: string,
    achRoutingNumber: string,
    achAccountNumber: string,
    taxDocumentFile: string,
    taxDocumentUploadedDateTime: string,
    payStubFile: string,
    payStubUploadedDateTime: string,
    centerManagementLink: string,
    verifyIncomeLink: string,
    verifyTravelLink: string,
    donationConfirmationLink: string,
    travelReceiptsLink: string,
    center: ICenterStatisticsView,
    donor: IDonor
}